import React, {SyntheticEvent, useEffect, useRef, useState} from "react"
import Popover from "../../../../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../core/gd-components/gd-popover/popover-position"
import {PopoverArrowEdgeInset} from "../../../../../../core/gd-components/gd-popover/@const"
import Workspace from "../../../../../../core/model2/space/workspaces/workspace"
import PopoverMenuOption from "../../../../../../core/gd-components/popover-menu/popover-menu/menu-option"
import MenuTopHeader_SearchActive from "../../../../components/top-header/search/search"
import {MenuSpaceSearch} from "../../../../components/search/menu-space-search"
import ProjectIconUI5 from "../../../../../../core/gd-components/icons/project/project-icon-ui5"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../core/gd-components/buttons/control-button/control-button-standard"
import {PopoverMenuItemType} from "../../../../../../core/gd-components/popover-menu/popover-menu/const"
import PopoverMenuHeader from "../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-header"
import PopoverMenuSeparator
    from "../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator"
import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {QuickAddItemType} from "../../../../../../app/quick-add/@types"

type Props = {
    spaceSearch : MenuSpaceSearch
    workspace   : Workspace
}

export default function NavigationMenu_WorkspaceDropdownSettings(props: Props) {

    const dropdownRef = useRef<HTMLDivElement>(null)
    const [popoverWidth, setPopoverWidth] = useState<number>(220)

    const [showPopover, setShowPopover] = React.useState(false)
    const [showSearchButton, setShowSearchButton] = React.useState(false)

    const canCreateWorkspace = gd.ac.check.company.canCreateWorkspace()

    const onMouseEnter = () => {
        setShowSearchButton(true)
    }

    const onMouseLeave = ()=> {
        setShowSearchButton(false)
    }

    const onToggleSearch = (e: SyntheticEvent)=> {

        e.stopPropagation()

        props.spaceSearch.isActive = true
        props.spaceSearch.reRender()
    }

    const togglePopover = ()=> {
        setShowPopover(!showPopover)
    }

    const hidePopover = ()=> {
        setShowPopover(false)
    }

    const openInfo = () => {
        hidePopover()
        gd.navigation.goToProject(props.workspace.project.id, '/info')
    }

    const openSettings = () => {
        hidePopover()
        gd.navigation.goToProject(props.workspace.project.id, '/info/settings')
    }

    const openUsers = () => {
        hidePopover()
        gd.navigation.goToProject(props.workspace.project.id, '/info/users')
    }

    const onAddNewSpace = () => {
        gd.layout.popovers.closeAll()
        gd.openNew(QuickAddItemType.SPACE)
    }

    let options: Options = []

    if (props.workspace.project.acl.hasFullAccess) {
        options = [
            ...options,
            ...[
                {
                    icon    : "ii5-information",
                    label   : "Workspace Info",
                    onClick : openInfo
                },
                {
                    icon    : "i5-users",
                    label   : "Users & Access",
                    counter : props.workspace.project.usersTotal,
                    onClick : openUsers
                },
                {
                    icon    : "i5-settings",
                    label   : "Settings",
                    onClick : openSettings
                }
            ]
        ]
    }

    if (
        props.workspace.project.acl.hasFullAccess
        && (
            !gd.spaces.workspaces.isEmpty
            || canCreateWorkspace
        )
    ) {
        options.push({
            type: PopoverMenuItemType.SEPARATOR
        })
    }

    if (!gd.spaces.workspaces.isEmpty) {
        options.push({
            type    : PopoverMenuItemType.HEADER,
            title   : "All Workspaces"
        })

        _.map(gd.spaces.workspaces.models, (space: Workspace)=> {
            options.push({
                iconComponent   : (
                    <ProjectIconUI5
                        className   = "m-r-12"
                        project     = {space.project}
                    />
                ),
                label           : space.project.name,
                onClick         : ()=> space.navigation.onClick?.(space.navigation)

            })
        })
    }

    const workspaceIcon = Classes("flex-row-center-center h-24 w-24 border-radius-4 m-r-10", "gd-c-{0}".f(props.workspace.project?.color))

    useEffect(() => {
        if (dropdownRef.current) {
            setPopoverWidth(dropdownRef.current.offsetWidth - 22)
        }
    }, [showPopover])

    return (
        <div ref            = {dropdownRef}
             className      = "menu-workspace-dropdown m-t-4"
             onMouseEnter   = {onMouseEnter}
             onMouseLeave   = {onMouseLeave}
        >
            {!props.spaceSearch.isActive &&
                <div className  = "ui5-field-form-editable dropdown-form h-36 m-l-10 m-r-10 m-b-10 p-l-6 p-r-60"
                     onClick    = {togglePopover}
                >
                    <div className  = {workspaceIcon}
                         style      = {{minWidth: 24}}
                    >
                        <ProjectIconUI5
                            className   = "ui5-color-white"
                            project     = {props.workspace.project}
                        />
                    </div>

                    <div className="dropdown-label txt-truncate ui5-title-app-name ui5-txt-bold-light fs-14">
                        {props.workspace.project.title}
                    </div>

                    {showSearchButton &&
                        <ControlButtonStandard
                            className   = "search-button"
                            style       = {{position: "absolute", right: 34, top: 3}}
                            type        = {ControlButtonType.SEARCH}
                            onClick     = {onToggleSearch}
                        />
                    }
                </div>
            }

            {props.spaceSearch.isActive &&
                <div className  = "top-header p-l-10 p-r-10"
                     style      = {{height: 46}}
                >
                    <MenuTopHeader_SearchActive
                        className       = "p-l-0 p-r-15"
                        inputClassname  = "h-36 border-radius-6 m-0"
                        spaceSearch     = {props.spaceSearch}
                    />
                </div>
            }

            {showPopover &&
                <Popover
                    position        = {PopoverPosition.bottomRight("-5, -10")}
                    arrowEdgeInset  = {PopoverArrowEdgeInset.ARROWS_V1}
                    onClickOutside  = {hidePopover}
                >
                    <div className  = "ui5-popover-menu"
                         style      = {{width: popoverWidth}}
                    >

                        <VScroll containerStyle={{maxHeight: "calc(100vh - 77px)"}}>
                            <>
                                {_.map(options, (option: Option, key: number) => {

                                    if (option.type === PopoverMenuItemType.HEADER) {
                                        return (
                                            <PopoverMenuHeader
                                                key={key}
                                                title={option.title}
                                            />
                                        )
                                    }

                                    if (option.type === PopoverMenuItemType.SEPARATOR) {
                                        return <PopoverMenuSeparator key={key}/>
                                    }

                                    return (
                                        <PopoverMenuOption
                                            key     = {key}
                                            option  = {option}
                                        />
                                    )
                                })}

                                {canCreateWorkspace &&
                                    <div className  = "option"
                                         onClick    = {onAddNewSpace}
                                    >
                                        <div className="flex-row-left-center">
                                            <div className="i5-space-add ui5-txt-link m-r-12"></div>
                                            <div className="ui5-txt-link">New Space</div>
                                        </div>
                                    </div>
                                }
                            </>
                        </VScroll>

                    </div>
                </Popover>
            }
        </div>
    )
}
